import { MapMarkerRadiusIcon } from './MapMarkerRadiusIcon';

/**
 * author: Austin Andrews
 * id 8F346B27-607A-4C98-B83E-C32E921D0468
 * name map-marker-radius
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-radius.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 * - Home Automation 
 */
export const LocationRadiusIcon = MapMarkerRadiusIcon;
export default LocationRadiusIcon